/**
 * Paleta de cores do projeto (fonte única).
 * Use em JS: import { theme } from "../theme/colors"
 * Use em SCSS: var(--main-6), var(--secondary-6), etc.
 * As variáveis CSS são injetadas no :root pelo injectCssVars (chamado no index.js).
 */
export const theme = {
  grayScale: {
    10: "#000000",
    9: "#222222",
    8: "#333333",
    7: "#555555",
    6: "#777777",
    5: "#999999",
    4: "#CCCCCC",
    3: "#E4E4E4",
    2: "#F9F9F9",
    1: "#FFFFFF",
  },
  mainColors: {
    10: "#0D0D0D",
    9: "#111111",
    8: "#151516",
    7: "#1B1B1C",
    6: "#1E1E1F",
    5: "#4B4B4C",
    4: "#686869",
    3: "#989898",
    2: "#B9B9BA",
    1: "#E9E9E9",
  },
  secondaryColors: {
    10: "#00353C",
    9: "#00454F",
    8: "#005966",
    7: "#007382",
    6: "#007E8F",
    5: "#3398A5",
    4: "#54A9B4",
    3: "#8AC4CB",
    2: "#B0D7DC",
    1: "#E6F2F4",
  },
  auxiliaryColors: {
    red: {
      5: "#C62828",
      4: "#E53935",
      3: "#EF5350",
      2: "#EF9A9A",
      1: "#FFEBEE",
    },
    orange: {
      5: "#EF6C00",
      4: "#FB8C00",
      3: "#FFA726",
      2: "#FFCC80",
      1: "#FFF3E0",
    },
    green: {
      5: "#2E7D32",
      4: "#43A047",
      3: "#66BB6A",
      2: "#A5D6A7",
      1: "#E8F5E9",
    },
  },
};
